import { render, staticRenderFns } from "./Testing2.vue?vue&type=template&id=574232c5&scoped=true&"
import script from "./Testing2.vue?vue&type=script&lang=js&"
export * from "./Testing2.vue?vue&type=script&lang=js&"
import style0 from "./Testing2.vue?vue&type=style&index=0&id=574232c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574232c5",
  null
  
)

export default component.exports